/*
 * Copyright (c) 2021 EGT Digital - All rights reserved.
 *
 * File: useEffectWithRef.tsx
 *
 * Written by Yuliyan Milenkov <yuliyan.milenkov@egt-digital.com> on  14.06.23 9:07 am.
 * Last modified: 14.06.23 9:07 am.
 *
 * More information at: https://egt-digital.com/
 */
import { useCallback, useRef } from 'react';

export const useEffectWithRef = (
    callbackFunc: (node: any) => void,
): [(node: any) => void, React.MutableRefObject<any>] => {
    const ref = useRef<any>(null);
    const setRef = useCallback((node: any) => {
        if (node) {
            callbackFunc(node);
        }

        ref.current = node;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return [setRef, ref];
};
